module.exports = __webpack_public_path__ + "img/512.lighting.eb4ae548.svg";